import { render, staticRenderFns } from "./NewSideBar.vue?vue&type=template&id=72c58016&scoped=true"
import script from "./NewSideBar.vue?vue&type=script&lang=js"
export * from "./NewSideBar.vue?vue&type=script&lang=js"
import style0 from "./NewSideBar.vue?vue&type=style&index=0&id=72c58016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c58016",
  null
  
)

export default component.exports